import React from "react";
import { Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import "./warningModal.scss";

import CancelSharpIcon from "@mui/icons-material/CancelSharp";

interface IMODAL {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: boolean;
  image: any;
  text: string;
}

const WarningModal: React.FC<IMODAL> = (props) => {
  return (
    <div className="login-modal">
      <Modal
        open={props.openModal}
        onClose={() => props.setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="login-modal-main"
      >
        <Grid
          container
          item
          className="modal"
          xs={11}
          sm={8}
          md={6}
          lg={6}
          xl={5}
        >
          <div className="modal-contant" style={{ width: "100%" }}>
            <CancelSharpIcon
              sx={{
                color: "gray",
                margin: "10px 10px 0 auto",
                cursor: "pointer",
              }}
              onClick={() => props.setOpenModal(false)}
            />
            <div className="modal-icon">
              <img src={props.image} alt="warning image" />
            </div>
            <p>{props.text}</p>
          </div>
        </Grid>
      </Modal>
    </div>
  );
};

export default WarningModal;
